import { useStaticQuery, graphql } from "gatsby"
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"
import { formatWebinars } from "utils/prismic"
import get from "lodash.get"
import SEO from "components/seo"
import Info from "components/organisms/webinar/Info"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"
import { useEffect, useContext } from "react"
import { createWidget } from "@typeform/embed"
import { LocaleContext } from "contexts"

const HeroImage = ({ image }) => {
  if (!image) {
    return <FallbackImage />
  }

  return (
    <GatsbyImage
      image={image}
      alt=""
      objectFit="cover"
      imgClassName="!bottom-0 lg:!bottom-[70px] !top-auto xl:!bottom-[160px]"
    />
  )
}

const FallbackImage = () => (
  <StaticImage
    src="../images/schools/AdobeStock_576257341.jpeg"
    alt=""
    objectFit="cover"
    layout="fullWidth"
    imgClassName="!bottom-0 lg:!bottom-[70px] !top-auto xl:!bottom-[160px]"
  />
)

const Hero = ({ title, image }) => {
  return (
    <div className="relative mx-auto overflow-hidden">
      <div className=" mx-auto w-full overflow-hidden sm:h-[20em] md:h-[20em] lg:h-[24em] xl:h-[32em] ">
        <HeroImage image={image} />
      </div>
      <div className="bg-kkm-green px-4 py-6 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl text-center">
          <h1 className="m-0 p-0 text-3xl font-bold tracking-tight text-zinc-900 sm:text-4xl">
            {title}
          </h1>
        </div>
      </div>
    </div>
  )
}

const SettTypeform = () => {
  const formId = "https://someturva.typeform.com/to/Kg6rQBKW"

  useEffect(() => {
    createWidget(formId, {
      container: document.querySelector("#Order"),
      hideHeaders: true,
      hideFooter: true,
    })
  }, [formId])

  return (
    <div
      id="Order"
      className="embedded-typeform-container mx-auto h-screen max-w-screen-lg  px-6 py-6 lg:px-8"
    />
  )
}

export default function Sett() {
  return (
    <div className="bg-kkm-darkgreen">
      <Hero title="Delta i utlottningen för att ha en möjlighet att vinna SomeBuddys expertföreläsning om säkerhet på sociala medier." />
      <SettTypeform />
    </div>
  )
}
